import {
  takeLatest, call, put, select
} from 'redux-saga/effects';
import {
  SET_LANGUAGE,
  LOAD_LANGUAGE_STRINGS_REQUEST,
  LOAD_LANGUAGE_STRINGS_SUCCESS,
  LOAD_LANGUAGE_STRINGS_ERROR
} from '../actions/index';

import $dataRepo from 'dataRepository';

const getLanguageStrings = (state, languageCode) => state.strings[languageCode];

// watcher saga: watches for actions dispatched to the store, starts worker saga
export default function* rootSaga() {
  yield takeLatest(SET_LANGUAGE, updateLanguage);
  yield takeLatest(LOAD_LANGUAGE_STRINGS_REQUEST, fetchLanguageStrings);
}

// worker sagas: makes the api call when watcher saga sees the action
function* updateLanguage(action) {
  const { languageCode } = action;
  const langStrings = yield select(getLanguageStrings, languageCode);
  if (!langStrings) {
    // load the strings
    yield put({ type: LOAD_LANGUAGE_STRINGS_REQUEST, languageCode });
  }
}

function* fetchLanguageStrings(action) {
  try {
    const { languageCode } = action;
    const loadedStrings = yield call($dataRepo.fetchLanguageStringData, languageCode);

    // success, store the content
    yield put({ type: LOAD_LANGUAGE_STRINGS_SUCCESS, loadedStrings, languageCode });
  } catch (error) {
    // error, reset content
    yield put({ type: LOAD_LANGUAGE_STRINGS_ERROR, error });
  }
}
